import { createSelector } from 'reselect';

const classroomsById = ({ entity }) => entity.classroomsById;
const selectedClassroomId = ({ app }) => app.selectedClassroomId;

export const getSelectedClassroom = createSelector(
  [classroomsById, selectedClassroomId],
  (classroomsById, selectedClassroomId) => {
    if (!selectedClassroomId) return null;
    return classroomsById[selectedClassroomId];
  }
);
